module.exports = __webpack_public_path__ + "static/img/WarmPlate (3).f35751bb.png";